export default "__VITE_ASSET__fef339ad__"